import AOS from 'aos';
import $ from 'jquery';

let loader = $('[js-loader]');

$(window).on('load', function(){
    loader.addClass('loaded');
    $('body').addClass('ready');

    if(loader.hasClass('loaded')){
        setTimeout(function(){
            AOS.init({
                disable: function(){
                    return window.matchMedia('(max-width:960px)').matches;
                },
                duration: 400,
                once: true
            });
        }, 500);

    }
});